import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const ScrollableContent = styled(Box)({
  height: '60vh',
  overflowY: 'auto',
  paddingBottom: '40px',
});
